import React from 'react';
import LandingNavBar from "../components/LandingNavBAr";
import '../styles/pricing.css';
import { useNavigate } from "react-router-dom";

function Pricing() {
  const navigate = useNavigate();

  return (
    <div className='pricing'>
      <>
        <LandingNavBar />

        <div className="container py-3">

          {/* header */}
          <header>
            <div className="pricing-header p-3 pb-md-4 mx-auto text-center rem5">
              <h1 className="slogan text-center">Pricing</h1>
              <p className="fs-5 text-body-secondary">For both plans, you must first register, when you register, the explorer plan is activated, for full access, you must make a payment in the payments section of the settings, or apply a discount promotion code.</p>
            </div>
          </header>

          <div className=" px-3 py-3 pb-md-4  ">
            {/* plans */}
            <div className="row row-cols-1 row-cols-md-2 mb-3 text-center">
              <div className="col">
                <div className="card mb-4 rounded-3 shadow-sm">
                  <div className=" head1 card-header py-3">
                    <h4 className="my-0 fw-normal">Explorer</h4>
                  </div>
                  <div className="card-body">
                    <h1 className="card-title pricing-card-title">$0<small className="text-body-secondary fw-light">/mo</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                      <li>user search</li>
                      <li>advanced filtering</li>
                      <li><p></p></li>
                      <li><p></p></li>
                    </ul>
                    <button onClick={() => navigate('/login')} type="button" className="w-100 btn btn-lg cardbutton">Get started</button>
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="card card2 mb-4 rounded-3 shadow-sm ">
                  <div className=" head2 card-header py-3 ">
                    <h4 className="my-0 fw-normal" style={{ color: "white" }} >Full Access</h4>
                  </div>
                  <div className="card-body">
                    <h1 className="card-title pricing-card-title">$7<small className="text-body-secondary fw-light">/mo</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                      <li>user search</li>
                      <li>advanced filtering</li>
                      <li>profile creation</li>
                      <li>add links</li>
                      <li>communicating</li>
                      <li>social media account verification</li>
                    </ul>
                    <button onClick={() => navigate('/login')} type="button" className=" cardbutton w-100 btn btn-lg ">Contact us</button>
                  </div>
                </div>
              </div>
            </div>
            {/* compare plans */}
          </div>

          {/* footer */}
          <div className="text-center mt-5">
            <p style={{ color: "black" }} className="m-0 pt-3 text-muted">&copy; 2024 GULDAG · All rights reserved.</p>
          </div>

        </div>
      </>
    </div>
  );
}
export default Pricing;